/* Correct Snapseek result prices with Shopify's Ajax Product API (minor units). */
(() => {
  'use strict';
  const script = document.currentScript;
  const root = (script?.dataset.routeRoot || '/').replace(/\/?$/, '/');
  const serverCurrency = script?.dataset.currency || 'USD';
  const cache = new Map();
  const pending = [];
  let running = 0;

  function enqueue(task) {
    return new Promise((resolve, reject) => {
      pending.push({ task, resolve, reject });
      drain();
    });
  }

  function drain() {
    while (running < 4 && pending.length) {
      const job = pending.shift();
      running += 1;
      Promise.resolve().then(job.task).then(job.resolve, job.reject).finally(() => {
        running -= 1;
        drain();
      });
    }
  }

  function currentCurrency() {
    return window.Shopify?.currency?.active || serverCurrency;
  }

  function productPrice(handle, currency) {
    const key = `${currency}:${handle}`;
    if (!cache.has(key)) {
      const request = enqueue(async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            signal: controller.signal,
          });
          if (!response.ok) throw new Error('Product price unavailable');
          const product = await response.json();
          const cents = product.price_min ?? product.price;
          if (typeof cents !== 'number' || !Number.isFinite(cents) || cents < 0) {
            throw new Error('Invalid product price');
          }
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
          }).format(cents / 100);
          return product.price_varies ? `From ${amount}` : amount;
        } finally {
          clearTimeout(timeout);
        }
      }).catch(error => {
        cache.delete(key);
        throw error;
      });
      cache.set(key, request);
    }
    return cache.get(key);
  }

  function verifyCard(card) {
    const price = card.querySelector('.snapseek-result-price');
    const handle = card.dataset.productHandle;
    if (!price || !handle || price.dataset.whPriceRequested) return;
    price.dataset.whPriceRequested = 'true';
    price.textContent = 'Checking price…';
    productPrice(handle, currentCurrency()).then(label => {
      price.textContent = label;
      price.dataset.whPriceVerified = 'true';
    }).catch(() => {
      price.textContent = 'View current price';
      price.dataset.whPriceVerified = 'unavailable';
    });
  }

  function bindGrid() {
    const grid = document.getElementById('snapseek-grid');
    if (!grid || grid.dataset.whPricesBound) return Boolean(grid);
    grid.dataset.whPricesBound = 'true';
    const scan = () => grid.querySelectorAll('.snapseek-result').forEach(verifyCard);
    new MutationObserver(scan).observe(grid, { childList: true });
    scan();
    const input = document.getElementById('snapseek-file');
    if (input) input.setAttribute('accept', 'image/*');
    const trigger = document.getElementById('snapseek-trigger');
    if (trigger) {
      trigger.setAttribute('aria-label', 'Search by photo');
      trigger.setAttribute('title', 'Search by photo');
    }
    return true;
  }

  function boot() {
    if (bindGrid()) return;
    const observer = new MutationObserver(() => {
      if (bindGrid()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
